import { QR_THEME_STYLE } from '../../qr-theme'
import { useEffect, useState } from "react"
import { PageComponent, Text } from "../../components"
import { API_BASE_URL } from '../../config'
import { PartnerPromo } from './components/partner-promo'
import './style.css'

interface PromoStore {
    id: number;
    isPartner?: boolean;
    spending_points?: number;
    raiting?: string | null;
}

interface GetQrAdminPromoPageProps {
    token: string;
    onUnauthorized?: () => void;
}

export const GetQrAdminPromoPage = ({token, onUnauthorized}: GetQrAdminPromoPageProps) => {
    const [store, setStore] = useState<PromoStore | null>(null)
    const [error, setError] = useState<string | null>(null)

    const loadStore = async () => {
        try {
            const storeRes = await fetch(`${API_BASE_URL}/get-my-store`, {headers: {Authorization: `Bearer ${token}`}})
            if (storeRes.status === 401) {
                onUnauthorized?.()
                return
            }
            if (!storeRes.ok) throw new Error('failed')
            const {store_id} = await storeRes.json()

            const linksRes = await fetch(`${API_BASE_URL}/get-links?store_id=${store_id}`)
            if (!linksRes.ok) throw new Error('failed')
            const data: PromoStore = await linksRes.json()
            setStore(data)
            return data
        } catch {
            setError('Не удалось загрузить данные')
        }
    }

    useEffect(() => {
        loadStore()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    if (!store) {
        return (
            <PageComponent style={QR_THEME_STYLE}>
                {error ? (
                    <Text size="s" color="lightGray">{error}</Text>
                ) : (
                    <div className="admin-loader">
                        <div className="loader-spinner" />
                    </div>
                )}
            </PageComponent>
        )
    }

    return (
        <PageComponent style={QR_THEME_STYLE} center={false}>
            <div className="admin-scroll">
                <PartnerPromo
                    store={store}
                    token={token}
                    onClose={() => window.location.assign('/admin')}
                    onChanged={loadStore}
                    onUnauthorized={onUnauthorized}
                />
            </div>
        </PageComponent>
    )
}
